import {Component, EventEmitter, inject, Output, PLATFORM_ID} from '@angular/core';
import {RecaptchaVerifier, signInWithPhoneNumber} from '@firebase/auth';
import {ActivatedRoute} from '@angular/router';
import {FIREBASE_AUTH} from '../../../../config/module.di.tokens';
import {ModalService} from '../../../../../services/modal.service';
import {SendSmsCodeComponent} from '../../modal/auth/send-sms-code/send-sms-code.component';
import {isPlatformBrowser, NgIf} from '@angular/common';

@Component({
  selector: 'app-auth-by-phone',
  imports: [NgIf],
  templateUrl: './auth-by-phone.component.html',
})
export class AuthByPhoneComponent {

  authenticationSucceed = false
  reCaptchaSolved = false;
  private reCaptchaVerifier?: RecaptchaVerifier

  @Output()
  onAuthenticated = new EventEmitter<void>()

  private onAuthenticatedCallBack?: (success: boolean) => void
  platformId = inject(PLATFORM_ID)
  route = inject(ActivatedRoute)
  auth = inject(FIREBASE_AUTH)
  sendSms = inject<ModalService<SendSmsCodeComponent>>(ModalService)

  async authenticate(phoneNumber: string, onAuthenticatedCallBack: (success: boolean) => void) {
    this.onAuthenticatedCallBack = onAuthenticatedCallBack

    if (this.auth.currentUser) {
      this.succeed()
      return
    }
    await this.sendPhoneCode(phoneNumber)
  }

  private async sendPhoneCode(phoneNumber: string) {
    if (!isPlatformBrowser(this.platformId)) return

    this.resetCaptcha()
    this.reCaptchaVerifier = new RecaptchaVerifier(this.auth, 'recaptcha-container', {
      size: 'invisible',
      callback: () => this.reCaptchaSolved = true,
    })

    let confirmation
    try {
      confirmation = await signInWithPhoneNumber(this.auth, phoneNumber, this.reCaptchaVerifier)
    } catch (e) {
      console.error('sendVerificationCode failed', e)
      this.fail()
      return
    }

    this.sendSms.open(SendSmsCodeComponent, {
      onClose: async phoneCode => {
        if (!phoneCode) {
          this.fail()
          return
        }
        try {
          await confirmation.confirm(phoneCode)
          this.authenticationSucceed = true
          this.succeed()
        } catch (e) {
          this.fail()
        }
      }
    })
  }

  private succeed() {
    this.resetCaptcha()
    this.onAuthenticated.emit()
    this.onAuthenticatedCallBack?.(true)
  }

  private fail() {
    this.resetCaptcha()
    this.onAuthenticatedCallBack?.(false)
  }

  private resetCaptcha() {
    this.reCaptchaSolved = false
    this.reCaptchaVerifier?.clear()
    this.reCaptchaVerifier = undefined
  }
}
